import * as React from 'react';
import {useState, useEffect} from 'react';
import {Grid, Typography} from '@material-ui/core';
import * as RestClient from '../services/restclient';
import DocentAboTLinkWithSubscriptionData from './DocentAboTLinkWithSubscriptionData';

export default function DocentAboTLinksWithSubscriptionData({account}) {
    const [docentAboTLinksWithSubscriptionData, setDocentAboTLinksWithSubscriptionData] = useState([]);

    useEffect(() => {
        if (account) {
            const af = async () => {
                const response = await RestClient.fetchData({endpoint: `tlinklicenses/docentAboTLinksWithSubscriptionData?account=${account.id}`});
                setDocentAboTLinksWithSubscriptionData(response.data);
            };
            af();
        }
    }, [account]);
    
    if (docentAboTLinksWithSubscriptionData.length === 0) return null;

    return <Grid container direction="row">
        <Grid item xs={12} style={{ margin: '16px', minWidth: '350px'}}>
            <Typography component="h1" variant="h5" gutterBottom noWrap>
                Subscription data
            </Typography>
            {docentAboTLinksWithSubscriptionData.map((dA, index) =>
                <DocentAboTLinkWithSubscriptionData data={dA} key={'da-id-' + index}/>)
            }
        </Grid>
    </Grid>
}